<div class="main-view">
  <header class="Flexbox Flexbox__direction-rows header top-template-header navigation-header-shade"
      style="position:absolute;z-index: 1001;" [hidden]="isEmbedded">
      <div *ngIf="forTestingPurposesOnly" id="forTestingPurposesOnlyAuto" class="dashboard-top-message-banner">
          <div class="message defaultCursor Spacebox__flat-l Auto_Title_Message">{{forTestingPurposesOnlyMessage}}</div>
      </div>
      <div class="top-template-header-content Flexbox">
          <div class="defaultCursor title logo-title"></div>
          <div style="display: inline-flex">
              <gen-navigation-bar></gen-navigation-bar>
          </div>
          <nav class="top-template-header-content-tools Flexbox">
              <div style="display: inline-flex">
                  <div *ngIf="searchBarEnabled" class="patient-search angucomplete-holder"
                      style="position: relative; padding-top: 0.35rem; margin-left:2.85rem;">
                      <gen-case-search></gen-case-search>
                  </div>
              </div>

            <section class="menus-wrapper">
                <div class="nav-ask-ai">
                    <gen-ask-ai></gen-ask-ai>
                </div>
              <div class="external-links">
                <gen-external-links></gen-external-links>
              </div>

              <ispm-disclaimer-viewer [ngClass]="{
                  'disclamer-view-text': disclaimerConfiguration.disclamerViewType == 'text',
                  'disclamer-view-icon': disclaimerConfiguration.disclamerViewType == 'icon' ||
                   disclaimerConfiguration.disclamerViewType == undefined
                }" [title]="title || ''" [text]="text || ''" [showDisclaimerModel]="showFirstTimePopup"
                  [approveBtnText]="approveBtnText" [disclamerConfig]="disclaimerConfiguration">
              </ispm-disclaimer-viewer>

              <div class="action-items">
                  <gen-info-menu [webConfig]="webConfig"></gen-info-menu>
                  <div class="top-template-header-content-item name fs5">
                      <span id="dash-fullname" class="fs7 flexbox__align-self-center pointer current-user"
                          (click)="toggleTools=!toggleTools" genTooltip [tooltipText]="getUserNameTooltip()"
                          [tooltipPosition]="'BOTTOM'" [tooltipShow]="nameTooltipEnabled()">{{getFullUserName()}}</span>
                      <div class="ngdialog-overlay" *ngIf="toggleTools" style="animation: none"
                          (click)="closeLogOutMenu()"></div>
                      <div class="toolsMenu" [ngClass]="{active: toggleTools}">

                          <section class="profile-info">
                              <span class="icon__close" (click)="toggleTools=!toggleTools"></span>
                              <div class="display-picture">
                                  <img *ngIf="user.info.photo && user.info.photo.length > 0 && user.info.photo[0]?.url" src="{{user.info.photo[0].url}}" alt="" />
                                  <span
                                      *ngIf="!user.info.photo || (user.info.photo && (user.info.photo.length === 0 || (user.info.photo.length > 0 && !user.info.photo[0].url)))">{{user.info.name[0].given[0][0]}}{{user.info.name[0].family[0][0]}}</span>
                              </div>
                              <div class="display-name fs5" id="auto_user_name">{{user.info.name[0].prefix[0] ? user.info.name[0].prefix[0] +
                                  '.' : ''}} {{user.info.name[0].given[0]}} {{user.info.name[0].family[0]}}</div>
                          </section>
                          <div *ngIf="isOrgAdminActionsAllowed()" id="goToAdminHomeAuto" class="Flexbox pointer menu-item"
                              (click)="toggleTools=false;goAdminHome()">
                              <span class="Spacebox__lr-small Spacebox__tb-small icon__admin_logo_new fs6"></span>
                              <span class="fs6 Spacebox__l-tiny Spacebox__tb-tiny" translate-default="Home">
                                  {{ "Admin Portal" | translate}}</span>
                          </div>

                          <div *ngIf="!user.isAdmin" class="Flexbox pointer menu-item" style="display: inline;">
                              <gen-facility-filter class="fs6" (onFacilityApply)="closeLogOutMenu()">

                              </gen-facility-filter>
                          </div>


                          <div class="Flexbox pointer menu-item" id="auto_logout_button" (click)="toggleTools=false;logout()">
                              <span class="Spacebox__lr-small Spacebox__tb-small icon__logout fs6" id="auto_logout_item"></span>
                              <span class="fs6 Spacebox__l-tiny Spacebox__tb-tiny" id="auto_logout_text">{{"Logout" | translate}}</span>
                          </div>
                          <div *ngIf="isAdminMicroService() && isDataModelToolAccess()" id="dataModelToolAuto" class="Flexbox pointer"
                              (click)="toggleTools=false;openDatamodelTool()">
                              <span class="Spacebox__lr-small Spacebox__tb-small icon__LinkExternal1 fs6"></span>
                              <span class="fs6 Spacebox__l-tiny Spacebox__tb-tiny"
                                  translate-default="Datamodel Tool">{{"Datamodel Tool" | translate}}</span>
                          </div>
                          <div *ngIf="isAdminMicroService() && isDataModelToolAccess()" id="valuesetToolAuto" class="Flexbox pointer"
                              (click)="toggleTools=false;openValuesetTool()">
                              <span class="Spacebox__lr-small Spacebox__tb-small icon__LinkExternal1 fs6"></span>
                              <span class="fs6 Spacebox__l-tiny Spacebox__tb-tiny"
                                  translate-default="Datamodel Tool">{{"Valueset Tool" | translate}}</span>
                          </div>
                      </div>
                      <span class="fs9 pointer" [ngClass]="{icon__expand:!toggleTools, icon__collapse:toggleTools}"
                          (click)="toggleTools=!toggleTools" style="padding-left: 0.75rem;"></span>
                  </div>
              </div>
            </section>
          </nav>
      </div>
  </header>

  <section class="main-page-content page-content" [ngClass]="{'main-page-content-testing-purposes': forTestingPurposesOnly,
  'embedded': isEmbedded}">
      <router-outlet></router-outlet>
  </section>
</div>
